import Vue from './app';
import store from './store'
import i18n from "./i18n";
import {captureUtmAttribution} from "./helpers/utm_attribution";

captureUtmAttribution();

new Vue({
  store,
  i18n,
  el: '#app',
});
